import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import HighchartsVue from 'highcharts-vue'
import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'
import usejwt from '@/auth/jwt/useJwt' 
// Global Components
import './global-components'

import '@axios'  
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import startAppVersionWatcher from '@/utils/checkAppVersion'






// JWT authentication
 Vue.use(usejwt)
// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueCompositionAPI) 
Vue.use(HighchartsVue)
// Composition API

require('dotenv').config()
// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')


Vue.config.productionTip = false
 
////console.log(process.env.VUE_APP_API_URL);
////console.log(process.env._VUE_APP_API_URL);


new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
//   ready() {
//   LocationPickerInit(
//     this,

//     // config object
//     {
//       key: 'AIzaSyCkVyfcqbbrrYcdQqsaJv2meHyiUV0Sjes', // required
//       language: 'en-US'        // optional
//     },

//     // options object
//     {
//       map: {
//         center: { lat: 0, lng: 0 },
//         /** other map options **/
//       },
//       marker: { /** marker options **/ },
//       infoWindow: { /** info window options **/ },
//       autocomplete: { /** autocomplete options **/ }
//     }
//   );
// }
}).$mount('#app')

startAppVersionWatcher()

// 4a8cff  acik mavi 
// 003ba3 koyu mavi   

